export const selectBot = (botId, bot) => ({
    type: 'SELECT_BOT',
    botId,
    bot,
});

export const openDialogBranch = ({ parentResponseID, nextResponseID, content }) => ({
    type: 'OPEN_DIALOG_BRANCH',
    parentResponseID,
    nextResponseID,
    content,
});

export const setDialogPath = (path) => ({
    type: 'SET_DIALOG_PATH',
    path,
});
